<!-- PAGE LOADER -->
<div class="page-progress position-fixed w-100" style="z-index: 9999; left: 0;">
  <mat-progress-bar mode="indeterminate" *ngIf="moduleLoading"></mat-progress-bar>
</div>

<div class="dashBoard main-wrapper">

  <app-sidebar class="side-menu"></app-sidebar>

  <div class="main-container container-fluid p-0">

    <app-header></app-header>

    <div *ngIf='!menuLoaded' class="dataLoading">
      <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
    <div class="container-fluid" *ngIf="menuLoaded">
      <div class="main-content">
        <!-- Breadcrumb -->
        <ul class="breadcrumb-items">
          @for (item of menuItems; track item.id; let isLast = $last) {
          <li>
            @if (!isLast && item.label !== 'reports') {
            <a [routerLink]="item.url" class="active">
              {{ 'routes.' + item.label | translate }}
              @if (item.title) { ( {{item.title}} ) }
            </a>
            }
            @else {
            <span class="label-text">
              {{ 'routes.' + item.label | translate }}
              @if (item.title) { ( {{item.title}} ) }
            </span>
            }

            @if (!isLast) {
            <span class="icon-split">
              <svg width="5" height="8" viewBox="0 0 5 8">
                <path d="M252.914,255.644l3.1,3.063-3.1,3.063.949.937,4.051-4-4.051-4Z"
                  transform="translate(-252.914 -254.707)" fill="#999" />
              </svg>
            </span>
            }
          </li>
          }
        </ul>
        <!-- End Breadcrumb -->

        <!-- Main Container -->
        <div id="content">
          <router-outlet></router-outlet>
        </div>

      </div>
    </div>

    <app-chat></app-chat>

  </div>
</div>
